// This import loads the firebase namespace along with all its type information.
import ProfileImage from './profile-image-model'

export async function load_profileImages(): Promise<ProfileImage[]> {
  throw 'Not implemented'
}

export async function delete_profileImage(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_profileImage(): Promise<ProfileImage> {
  throw 'Not implemented'
}
